export const HISTORICAL_NOTES_TYPES = {
    USER: 'user',
    CLIENT: 'client',
    JOB_OPPORTUNITY: 'jobOpportunity',
    JOB_APPLICATION: 'jobApplication',
};

export const MAX_DESCRIPTION_LENGTH = 20000;
